//
//
//
//
//
//
//

export default {
name: "LinkIcon"
}
